module.exports = __webpack_public_path__ + "static/media/LogoCPService.4ef03e8f.png";